export default __webpack_public_path__ + "static/media/productA.8c805153.jpg";